import React, { useId } from 'react'
import PropTypes from 'prop-types'

const SettingsVerticalIcon = React.forwardRef(function SettingsVerticalIcon(
  props,
  ref
) {
  const { color, size, ...otherProps } = props

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 8C4.55228 8 5 8.44772 5 9V21C5 21.5523 4.55228 22 4 22 3.44772 22 3 21.5523 3 21V9C3 8.44772 3.44772 8 4 8ZM4 2C4.55228 2 5 2.44772 5 3V5C5 5.55228 4.55228 6 4 6 3.44772 6 3 5.55228 3 5V3C3 2.44772 3.44772 2 4 2ZM20 11C20.5523 11 21 11.4477 21 12V21C21 21.5523 20.5523 22 20 22 19.4477 22 19 21.5523 19 21V12C19 11.4477 19.4477 11 20 11ZM20 2C20.5523 2 21 2.44772 21 3V8C21 8.55228 20.5523 9 20 9 19.4477 9 19 8.55228 19 8V3C19 2.44772 19.4477 2 20 2ZM12 15C12.5523 15 13 15.4477 13 16V21C13 21.5523 12.5523 22 12 22 11.4477 22 11 21.5523 11 21V16C11 15.4477 11.4477 15 12 15ZM12 2C12.5523 2 13 2.44772 13 3V12C13 12.5523 12.5523 13 12 13 11.4477 13 11 12.5523 11 12V3C11 2.44772 11.4477 2 12 2Z"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 9C1 8.44772 1.44772 8 2 8H6C6.55228 8 7 8.44772 7 9 7 9.55228 6.55228 10 6 10H2C1.44772 10 1 9.55228 1 9ZM9 16C9 15.4477 9.44772 15 10 15H14C14.5523 15 15 15.4477 15 16 15 16.5523 14.5523 17 14 17H10C9.44772 17 9 16.5523 9 16ZM17 12C17 11.4477 17.4477 11 18 11H22C22.5523 11 23 11.4477 23 12 23 12.5523 22.5523 13 22 13H18C17.4477 13 17 12.5523 17 12Z"
      ></path>
    </svg>
  )
})

SettingsVerticalIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

SettingsVerticalIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default SettingsVerticalIcon
